<div cdkDrag cdkDragRootElement=".modal-dialog">
<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header" cdkDragHandle>
    <div class="p-2 modal-title"><h5>Testbed {{taskDoc?.type|ucwords}}</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onClose()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-3" [ngClass]="bSaving||bLoadingTask ?'disabled':''">
    <div *ngIf="bSaving||bLoadingTask" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Please wait...
    </div>
    <form #taskForm="ngForm">
        <div *ngLet="usersById[tmpTask?.assignments?.scheduleUserId] as scheduler;">
            <div class="d-flex flex-row p-2">
                <label for="stageSelect" class="h5 my-auto mr-2">Stage</label>
                <div *ngIf="tmpTask">
                    <select name="stage" class="form-control"
                        [disabled]="!bNewDoc"
                        [(ngModel)]="tmpTask.stage" #stageSelect="ngModel" required
                        [ngClass]="{ 'invalid-input': stageSelect.invalid && (stageSelect.dirty || stageSelect.touched)}">
                        <option *ngFor="let stage of stages" [ngValue]="stage">{{stage}}</option>
                    </select>
                    <span *ngIf="stageSelect.invalid" class="text-danger small font-italic">* Required</span>
                </div>
            </div>
            <div class="card p-2 m-2">
                <div class="d-flex flex-row">
                    <label for="buildingIdSelect" class="h5 my-auto mr-2">Building</label>
                    <div *ngIf="tmpTask">
                        <select name="buildingId" class="form-control"
                            [disabled]="!bNewDoc"
                            #buildingIdSelect="ngModel" required
                            [(ngModel)]="tmpTask.buildingId" (ngModelChange)="onBuildingIdChanged($event)"
                            [ngClass]="{ 'invalid-input': buildingIdSelect.invalid && (buildingIdSelect.dirty || buildingIdSelect.touched)}">
                            <option *ngFor="let buildingInfo of buildingInfoArray" [ngValue]="buildingInfo.id">
                                {{buildingInfo.id}} - {{buildingInfo.name}}
                            </option>
                        </select>                
                    <span *ngIf="buildingIdSelect.invalid" class="text-danger small font-italic">* Required</span>
                    </div>
                </div>    
                <div *ngrxLet="building$; let building; let error = $error;"
                        class="pt-2">
                    <div *ngIf="bLoadingBuilding" class="font-weight-bold busy-overlay">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <div class="alert alert-danger" *ngIf="error">{{error}}</div>
                    <div class="d-flex flex-wrap justify-content-start">
                        <div class="mr-2">
                            <table class="table table-striped table-sm my-0">
                                <tbody>
                                <tr>
                                    <th>Market</th>
                                    <td *ngIf="building?.market; else emptyTableCell">{{building?.market}}</td>
                                </tr>
                                <tr>
                                    <th>Address</th>
                                    <td *ngIf="building?.civicAddress; else emptyTableCell">{{building?.civicAddress}}</td>
                                </tr>
                                </tbody>
                            </table>    
                        </div>
                        <div class="mr-2">
                            <table class="table table-striped table-sm my-0" style="border-radius:3px;">
                                <tbody>
                                <tr>
                                    <th>Contact</th>
                                    <td *ngIf="building?.contactName; else emptyTableCell">{{building?.contactName}}</td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td *ngIf="building?.contactNumber; else emptyTableCell">{{building?.contactNumber}}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td *ngIf="building?.contactEmail; else emptyTableCell">{{building?.contactEmail}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <ng-template #emptyTableCell>
                            <td class="text-secondary px-5"></td>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="card p-2 m-2">                
                <label class="h5 my-auto mr-2">Schedule</label>
                <div class="mr-2" style="width:12em;">
                    <table class="table table-sm my-0">
                        <tr>
                            <th style="border-bottom: none;">Status</th>
                            <td class="p-0 m-0" [ngClass]="taskStatus?.id|taskStatusCss">
                                <div *ngIf="taskStatus" class="p-1 h-100">
                                    <div class="my-auto text-center">                                        
                                        {{taskStatus.id|taskStatusName|titlecase}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="d-flex flex-row pt-1">
                    <div class="mr-2">
                        <table class="table table-sm my-0">
                            <tr>
                                <th>Requested Date</th>
                                <td>
                                    <div *ngIf="tmpTask">
                                        <input type="date" name="schedule.scheduleRequestedDate" class="form-control"
                                        [disabled]='!roleMgr.canAssignScheduler'
                                        [(ngModel)]="tmpTask.schedule.scheduleRequestedDate" #requestedDateInput="ngModel" 
                                        [ngClass]="{ 'invalid-input': requestedDateInput.invalid && (requestedDateInput.dirty || requestedDateInput.touched)}">
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>Scheduler</th>
                                <td>
                                    <div *ngIf="tmpTask">
                                        <select name="assignments.scheduleUserId" class="form-control"
                                            [disabled]='!roleMgr.canAssignScheduler'
                                            [(ngModel)]="tmpTask.assignments.scheduleUserId" #scheduleUserSelect="ngModel" 
                                            [ngClass]="{ 'invalid-input': scheduleUserSelect.invalid && (scheduleUserSelect.dirty || scheduleUserSelect.touched)}">
                                            <option *ngFor="let userInfo of userInfoArray | filterBy: ['role'] : ['scheduler']" [ngValue]="userInfo.id">{{userInfo.name}}</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!roleMgr.canAssignScheduler && !scheduler">
                                <td colspan=2 class="small font-italic">
                                    * PM or Admin role required
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <table class="table table-sm my-0">
                            <tr>
                                <th>Scheduled Date</th>
                                <td>
                                    <div *ngIf="tmpTask">
                                        <input type="date" name="schedule.scheduledDate" class="form-control"
                                        [disabled]='!roleMgr.isAdmin && !(roleMgr.canSchedule && (scheduler && scheduler.id == currentUserId))'
                                        [(ngModel)]="tmpTask.schedule.scheduledDate" #scheduleDateInput="ngModel" 
                                        [ngClass]="{ 'invalid-input': scheduleDateInput.invalid && (scheduleDateInput.dirty || scheduleDateInput.touched)}">
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>Assigned To</th>
                                <td>
                                    <div *ngIf="tmpTask">
                                        <select name="assignments.testUserId" class="form-control" 
                                            [disabled]='!roleMgr.isAdmin && !(roleMgr.canSchedule && (scheduler && scheduler.id == currentUserId))'
                                            [(ngModel)]="tmpTask.assignments.testUserId" #assignedUserSelect="ngModel" 
                                            [ngClass]="{ 'invalid-input': assignedUserSelect.invalid && (assignedUserSelect.dirty || assignedUserSelect.touched)}">
                                            <option *ngFor="let userInfo of userInfoArray | filterBy: ['role'] : 'field'" 
                                                [ngValue]="userInfo.id">{{userInfo.name}}</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="roleMgr.canSchedule && !roleMgr.canSchedule && !scheduler?.id">
                                <td colspan=2 class="small font-italic">
                                    * PM user must assign scheduler
                                </td>
                            </tr>
                            <tr *ngIf="!roleMgr.canSchedule || scheduler?.id != currentUserId">
                                <td colspan=2 class="small font-italic">                                    
                                    <ng-container *ngIf="scheduler&&roleActionPermissions[scheduler.role]">
                                        <ng-container *ngIf="roleActionPermissions[scheduler.role]?.canSchedule; else schedulerMissingPermission">
                                        * Editable by "{{scheduler.name}}"
                                        </ng-container>
                                        <ng-template #schedulerMissingPermission>
                                            <span class="text-danger">
                                                * "{{scheduler.name}}" missing scheduler role (role={{scheduler.role}})
                                            </span>
                                        </ng-template>
                                    </ng-container>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div *ngIf="tmpTask" class="mx-1">
                    <span class="gray font-italic pl-2">Access Procedures/Notes</span>
                    <textarea name="schedule.scheduleNotes" [(ngModel)]="tmpTask.schedule.scheduleNotes" rows="4" class="w-100" 
                        style="resize: none" #scheduleNotes="ngModel"
                    [ngClass]="{ 'invalid-input': scheduleNotes.invalid && (scheduleNotes.dirty || scheduleNotes.touched)}"></textarea>
                </div>
    
                <div class="pt-2" *ngIf="taskDoc?._id">
                    <app-task-schedule-comments #taskScheduleComments [taskDoc]="taskDoc"></app-task-schedule-comments>
                </div>
            </div>

        </div>
    </form>
</div>

<div class="modal-footer">
    <div class="d-flex flex-row justify-content-between w-100">
        <div>
        <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
            {{errorMsg|shorten:200:'...'}}
            <div role="button" (click)="errorMsg=''" class="ml-2"><i class="fa fa-times"></i></div>
        </div>
        </div>
        <div>
            <div class="btn-group" dropdown
                [isDisabled]="bSaving || bLoadingPointIds">
                <button [disabled]="bSaving || bLoadingPointIds || !taskForm.dirty || taskForm.invalid"
                        (click)="onSave();onSaveScoutList();" class="btn btn-primary">
                    Save
                </button>
            </div>
            &nbsp;
            <button (click)="onClose()" class="btn btn-secondary">
                Close
            </button>
        </div>        
    </div>
</div>
</div>